import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { reset, set } from '../actions/breadcrumbs.actions';

export const useBreadcrumbs = (breadcrumbConfig, isLoading, data) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading) {
      dispatch(set(breadcrumbConfig.LOADING()));
    } else {
      dispatch(set(breadcrumbConfig.LOADED(data)));
    }

    return () => dispatch(reset());
  }, [dispatch, breadcrumbConfig, data, isLoading]);
};
